import { GlobalRoutes, RouteKey } from 'GlobalRoutes';
import { useWorkspaceID } from 'hooks/useWorkspaceID';

export const useRoute = (route?: RouteKey): string => {
  const workspaceID = useWorkspaceID();
  if (!workspaceID || !route) return '';
  return GlobalRoutes[route].replace(':org', workspaceID);
};
